<po-page-default
  [p-breadcrumb]="breadcrumb"
  p-title="Expedição - Liberar Pedido"
>
  <po-lookup
    class="po-md-4"
    name="codigoCliente"
    [(ngModel)]="codigoCliente"
    p-field-label="CA1NREDUZ"
    p-field-value="CA1COD"
    p-label="Cliente"
    [p-columns]="columnsClienteFilters"
    [p-field-format]="fieldFormaterClienteFilters"
    [p-filter-service]="clienteLookupService"
    [p-advanced-filters]="advancedClienteFilters"
    [p-literals]="{ modalTitle: 'Cliente' }"
    (p-selected)="clienteSelecionado($event)"
  >
  </po-lookup>

  <po-table class="po-sm-12 po-md-12 po-lg-12"
    #poTablePrincipal
    [p-height]="600"
    [p-selectable]="true"
    [p-hide-select-all]="true"
    [p-sort]="true"
    [p-striped]="true"
    [p-columns]="tabelaPrincipalColunas"
    [p-items]="tabelaPrincipalItens"
    (p-unselected)="verificaSubtracaoEtiqueta($event)"
    (p-selected)="verificaSomaEtiqueta($event)"
    p-spacing="small"
  ></po-table>
  <po-button class="po-md-12" p-kind="secondary" p-label="Liberar Pedidos" (p-click)="liberarPedidos()" > </po-button>

</po-page-default>
